module.exports = __webpack_public_path__ + "static/media/cci.19f2a53f.png";